import { useEffect } from "react";
import { applySeoTags } from "@/lib/seo";

export default function StandaloneHtmlFramePage({ source, title, rootTestId, frameTestId, seo }) {
  useEffect(() => {
    const previousTitle = document.title;
    const nextTitle = seo?.title || title || previousTitle;
    const nextDescription = seo?.description || "Dimerse briefing page";

    applySeoTags({
      title: nextTitle,
      description: nextDescription,
      canonicalPath: seo?.canonicalPath || window.location.pathname,
    });

    return () => {
      document.title = previousTitle;
    };
  }, [seo?.canonicalPath, seo?.description, seo?.title, title]);

  return (
    <div
      style={{
        width: "100%",
        minHeight: "100vh",
        background: "#fff",
      }}
      data-testid={rootTestId || "standalone-html-root"}
    >
      <iframe
        src={source}
        title={title || "Standalone HTML page"}
        data-testid={frameTestId || "standalone-html-iframe"}
        loading="eager"
        style={{
          width: "100%",
          minHeight: "100vh",
          border: "none",
          display: "block",
        }}
      />
    </div>
  );
}
